/* [BD feat] Subscription parallax — bd-subscription.js
   Figma 890:13119 / 976:24249 — “Same parallax as mobile”.
   Targets .bd-subscription__decor-motion (rotation + vertical drift).
   Outer .bd-subscription__decor keeps frame placement (incl. desktop translateY(-50%)).
   data-bd-tilt = mobile resting ° · data-bd-tilt-desktop = ≥990px resting °
   Full tilt at viewport edges → 0° at centre. */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var items = Array.prototype.slice.call(document.querySelectorAll('[data-bd-parallax]'));
  if (!items.length) return;

  var SPEED = 55;
  var MQ_DESKTOP = window.matchMedia('(min-width: 990px)');
  var ticking = false;

  function tiltFor(el) {
    var isDesktop = MQ_DESKTOP.matches;
    var raw = isDesktop ? el.getAttribute('data-bd-tilt-desktop') : el.getAttribute('data-bd-tilt');
    if (raw === null || raw === '') {
      raw = el.getAttribute('data-bd-tilt');
    }
    return parseFloat(raw) || 0;
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    items.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var progress = (rect.top + rect.height / 2 - vh / 2) / (vh / 2);
      progress = Math.max(-1, Math.min(1, progress));
      var dir = parseFloat(el.getAttribute('data-bd-parallax')) || 0;
      var tilt = tiltFor(el);
      var rot = (tilt * Math.abs(progress)).toFixed(2);
      el.style.transform =
        'translate3d(0,' + (progress * SPEED * dir).toFixed(2) + 'px,0) rotate(' + rot + 'deg)';
    });
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (MQ_DESKTOP.addEventListener) {
    MQ_DESKTOP.addEventListener('change', onScroll);
  } else if (MQ_DESKTOP.addListener) {
    MQ_DESKTOP.addListener(onScroll);
  }
  update();
})();
/* [/BD feat] */
